// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeArtice_articleTitle__5pKG5","content":"noticeArtice_content__KWJHN"};